import React from 'react';
import PropTypes from 'prop-types';

import './vertical-action-panel.scss';

export function VerticalActionPanel({ children, bottomAction = null }) {
  return (
    <div className="vertical-action-panel d-flex flex-column align-items-start h-100 flex-shrink-0 overflow-visible pt-2 pb-1_5">
      <div className="d-flex flex-column align-items-start gap-1">{children}</div>
      {bottomAction && <div className="mt-auto">{bottomAction}</div>}
    </div>
  );
}

VerticalActionPanel.propTypes = {
  children: PropTypes.node.isRequired,
  bottomAction: PropTypes.node,
};
